import React, { useState, createRef, useEffect } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import config from "../../config";

import Auth_brand from "./Auth_brand";

const Forgot_otp = () => {
  const location = useLocation();
  let navigate = useNavigate();

  const [state, setState] = React.useState({
    email: location.state.email,
    otp: "",
  });
  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
  });
  const axios_registration_api = (event) => {
    // event.preventDefault();
    if (state.email != "" && state.otp != "") {
      let full_api = config.apiUrl + `/user/forgot_otp_verification`;
      let sendData = { email: state.email, otp: state.otp };

      axios
        .post(full_api, sendData, { headers: config.headers })
        .then((res) => {
          if (res.data.status == true) {
            let sendState = { email: state.email };
            Toast.fire({
              background: "#3659cd",
              type: "success",
              title: res.data.message,
              color: "white",
            });
            setTimeout(() => {
              navigate("/create_password", { state: sendState });
            }, 2000);
          } else {
            Toast.fire({
              background: "#a61c09",
              type: "unsuccess",
              title: res.data.message,
              color: "white",
            });
          }
        })
        .catch((e) => {});
    }
  };
  const handleChangeBroker = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/assets/js/elite.js?v=27";
    script.async = false;

    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);
  return (
    <div>
      <section class="auth-page">
        <div class="auth-form-panel">
          <div class="auth-form-wrap">
            <header>
              <a href="/login" class="auth-logo" aria-label="KalpCargo home">
                <span class="auth-logo-mark">K</span>
                <span class="auth-logo-name">KalpCargo</span>
              </a>

              <div class="auth-heading">
                <h1 class="auth-title">Verify your email</h1>
                <p class="auth-subtitle">
                  We sent a 6-digit code to your inbox. Check your email or spam
                  folder and enter it below.
                </p>
              </div>
            </header>

            <form
              onSubmit={(e) => {
                e.preventDefault(); // Prevent the default form submission behavior
                axios_registration_api(); // Call your login function
              }}
              class="auth-form"
            >
              <div class="auth-field">
                <label class="form-label" for="otp">
                  Verification code
                </label>
                <input
                  type="text"
                  class="form-control"
                  id="otp"
                  name="otp"
                  onChange={(e) => handleChangeBroker(e)}
                  placeholder="Enter 6-digit code"
                  inputmode="numeric"
                  autocomplete="one-time-code"
                  maxlength="6"
                  autofocus
                  required
                />
              </div>

              {/* <p class="auth-resend">
                Didn't get the code? <a href="forgot.php">Resend</a>
              </p> */}

              <button type="submit" class="btn btn-primary auth-submit">
                <span class="auth-spinner" aria-hidden="true"></span>
                <span class="auth-submit-label">Verify OTP</span>
                <i class="bi bi-arrow-right"></i>
              </button>
            </form>

            <p class="auth-signup">
              <a href="/login">Back to login</a>
            </p>
          </div>
        </div>

        <Auth_brand />
      </section>
    </div>
  );
};

export default Forgot_otp;
